export default __webpack_public_path__ + "static/media/Thumb_Top_06.dcf458b9.png";